import { OpenImageViewerShell, type OpenImageViewerConfig } from '@/features/open-image-viewer'
import { useT } from '@/shared/i18n'

export function JpgViewerPage() {
  const t = useT()
  const config: OpenImageViewerConfig = {
    analyticsContext: {
      app: 'imgify',
      domain: 'imgify.ru',
      route: '/otkryt-jpg',
      utility: 'jpg-viewer',
      processingMode: 'local',
    },
    accept: '.jpg,.jpeg,image/jpeg',
    acceptedMimeTypes: ['image/jpeg', 'image/jpg'],
    acceptedExtensions: ['.jpg', '.jpeg'],
    maxFileSizeBytes: 50 * 1024 * 1024,
    maxPixels: 36_000_000,
    formatLabel: 'JPG',
    exportFormats: ['png'],
    convertHref: '/konverter-izobrazheniy',
    acceptedByEditors: true,
    relatedTools: t.jpgViewer.relatedTools,
  }

  return <OpenImageViewerShell copy={t.jpgViewer} config={config} />
}
